
export const employeeData = [
    {id:1,name:'Ravi',phone:9847653789,location:'Vellore',email:'r@gmail.com'},
    {id:2,name:'Bala',phone:23456789,location:'Chennai',email:'b@gmail.com'},
]